import { useEffect, useState } from "react";
import CustomModal from "shared/components/modal/CustomModal";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { Cond21CloudResponse } from "types/response/Cond21CloudResponse";
import { ResponsePayloadBuscaConfiguracaoGroupPay } from "types/response/groupPay/ResponsePayloadBuscaConfiguracaoGroupPay";
import { Grid, IconButton, Typography } from "@material-ui/core";
import stylesModalConfiguracaoBuscaExternaStyles from "./styles/ModalConfiguracaoBuscaExternaStyles";
import { useForm } from "react-hook-form";
import { FaRepeat } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import { Col, Row } from "react-bootstrap";
import { usePostConfigurarGroupPay } from "hooks/groupPay/usePostConfigurarGroupPay";
import { ConfigurarGroupPayRequest } from "types/request/groupPay/ConfigurarGroupPayRequest";
import { AiFillQuestionCircle } from "react-icons/ai";
import ModalReplicarAcesso from "./ModalReplicarAcesso";
import StandardModalBuscaExternaNf from "shared/components/standardModal/StandardModalBuscaExternaNf";
import ConfigurarCertificado from "./ConfigurarCertificado";
import ConfigurarPrefeitura from "./ConfigurarPrefeitura";
import { RiErrorWarningFill } from "react-icons/ri";
import { ConfiguracaoBuscaExternaSchema } from "./schemas/ConfiguracaoBuscaExternaSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-hot-toast";
import StandardModal from "shared/components/standardModal/StandardModal";
import showAlert from "shared/util/functions/alert/showAlert";
import { useQueryClient } from "react-query";
import { possuiMensagemDeErro } from "shared/util/functions/errors/RequestPossuiMensagemDeErro";
import { getMensagemDeErroBackend } from "shared/util/functions/errors/GetMensagemDeErroBackend";

type ModalConfiguracaoBuscaExternaProps = {
  showModal: boolean;
  condominioId: number | null;
  condominio: any;
  closeModal: (value: boolean) => void;
  onConfiguracaoSalva?: (condominioId: number) => void;
  setShowModalConfiguracaoBuscaExterna: (value: boolean) => void;
};

type FormData = {
  condominiosIds: number[] | null;
  loginPrefeitura: string | null;
  senhaPrefeitura: string | null;
  certificadoDigitalBase64: string | null;
  senhaCertificadoDigital: string | null;
  nomeCertificadoDigital: string | null;
  permitirBuscaLancamentoNF: boolean | null;
};

const ModalConfiguracaoBuscaExterna = ({
  showModal,
  closeModal,
  condominioId,
  condominio,
  onConfiguracaoSalva,
  setShowModalConfiguracaoBuscaExterna,
}: ModalConfiguracaoBuscaExternaProps) => {
  const [openModalReplicarAcesso, setOpenModalReplicarAcesso] = useState<boolean>(false);
  const [showModalConfiguracao, setShowModalConfiguracao] = useState<boolean>(false);
  const [showModalAjuda, setShowModalAjuda] = useState<boolean>(false);
  const [showModalErrors, setShowModalErrors] = useState<boolean>(false);
  const [errorFederal, setErrorFederal] = useState<string | null>(null);
  const [errorMunicipal, setErrorMunicipal] = useState<string | null>(null);
  const [jaPossuiConfiguracaoPrefeitura, setJaPossuiConfiguracaoPrefeitura] = useState<boolean>(false);
  const [errorContent, setErrorContent] = useState({
    conteudoPrimario: "",
    conteudoSecundario: "",
    footerPrimaryLabel: "",
    onFooterPrimaryClick: () => {},
  });

  const styles = stylesModalConfiguracaoBuscaExternaStyles();
  const { mutateAsync } = usePostConfigurarGroupPay({
    successMessage: (
      <div>
        <strong>Condomínio configurado</strong>
        <div>As informações de acesso foram validadas</div>
      </div>
    )
  });
  const { register, handleSubmit, control, setValue, getValues, reset, watch, formState } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      condominiosIds: [],
      nomeCertificadoDigital: "",
      certificadoDigitalBase64: "",
      senhaCertificadoDigital: "",
      loginPrefeitura: "",
      senhaPrefeitura: "",
      permitirBuscaLancamentoNF: false,
    },
    resolver: yupResolver<FormData | any>(ConfiguracaoBuscaExternaSchema),
  });

  const loginPrefeitura = watch("loginPrefeitura");
  const senhaPrefeitura = watch("senhaPrefeitura");
  const certificado = watch("certificadoDigitalBase64");
  const senhaCertificado = watch("senhaCertificadoDigital");

  const credenciaisPrefeituraPreenchidas = loginPrefeitura && senhaPrefeitura;
  const certificadoPreenchido = certificado && senhaCertificado;

  const isBotaoHabilitado = credenciaisPrefeituraPreenchidas || certificadoPreenchido;

  const isDirty = Object.keys(formState.dirtyFields).length > 0;

  const queryClient = useQueryClient();

  const handleClose = (salvando: boolean = false) => {
    if (isDirty && !salvando) {
      showAlert({
        texto: "Existem alterações que não foram salvas na tela. Tem certeza de que deseja sair sem salvar?",
        tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
        onConfirm: () => {
          closeModal(false);
          setOpenModalReplicarAcesso(false);
          reset();
        },
      });
    } else {
      closeModal(false);
      setOpenModalReplicarAcesso(false);
      reset();
    }
  };

  const handleOpenModalReplicarAcesso = () => {
    queryClient.invalidateQueries(["tabela-condominios-group-pay"]);
    setOpenModalReplicarAcesso(true);
  };

  const handleCloseModalReplicarAcesso = () => {
    setOpenModalReplicarAcesso(false);
  };

  const getDadosConfiguracao = async () => {
    try {
      const resp = await http.get<Cond21CloudResponse<ResponsePayloadBuscaConfiguracaoGroupPay>>(
        api.groupPay.getConfiguracaoGroupPay + `/${condominioId}`
      );

      if (resp?.data.payload) {
        const novosValores = {
          loginPrefeitura: resp.data.payload?.usuarioPrefeitura || "",
          senhaPrefeitura: resp.data.payload?.senhaPrefeitura || "",
          nomeCertificadoDigital: resp.data.payload?.nomeCertificadoDigital || "",
          senhaCertificadoDigital: resp.data.payload?.senhaCertificadoDigital || "",
          certificadoDigitalBase64: resp.data.payload?.certificadoDigitalBase64 || "",
          condominiosIds: [],
          permitirBuscaLancamentoNF: false,
        };
        reset(novosValores);

        const possuiConfiguracaoPrefeitura = !!resp.data.payload?.usuarioPrefeitura || !!resp.data.payload?.senhaPrefeitura
        setJaPossuiConfiguracaoPrefeitura(possuiConfiguracaoPrefeitura);
        setErrorFederal(resp.data.payload?.stackTraceErroFederal || null);
        setErrorMunicipal(resp.data.payload?.stackTraceErroMunicipal || null);
      }
    } catch (err) {
      console.error("Erro ao buscar configuração: ", err);
    }
    setShowModalConfiguracao(true);
  };

  useEffect(() => {
    if (showModal && condominioId) {
      getDadosConfiguracao();
    } else {
      setShowModalConfiguracao(showModal);
    }
  }, [showModal, condominioId]);

  const onSubmit = async (data: FormData) => {
    const configurarConsultaNotaFiscalRequest = {
      condominiosIds: [condominioId],
      loginPrefeitura: data.loginPrefeitura,
      senhaPrefeitura: data.senhaPrefeitura,
      nomeCertificadoDigital: data.nomeCertificadoDigital,
      senhaCertificadoDigital: data.senhaCertificadoDigital,
      certificadoDigitalBase64: data.certificadoDigitalBase64,
      permitirBuscaLancamentoNF: true,
    } as ConfigurarGroupPayRequest;

    await mutateAsync(configurarConsultaNotaFiscalRequest)
      .then(() => {
        if (condominioId && onConfiguracaoSalva) {
          onConfiguracaoSalva(condominioId);
        }
        handleClose(true);
      })
      .catch((erro) => {
        toast.error(
          possuiMensagemDeErro(erro)
            ? getMensagemDeErroBackend(erro)
            : "Erro ao configurar o Group Pay"
        );
        getDadosConfiguracao();
      });
  };

  const handleOpenModalAjuda = () => {
    setShowModalAjuda(true);
  };

  const handleCloseModalAjuda = () => {
    setShowModalAjuda(false);
  };

  const Content = () => {
    return (
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="body2">
            {`Nossa IA vai acessar os portais da `}
            <span className={styles.textoDestaque}>prefeitura e da SEFAZ</span>
            {` para buscar automaticamente as `}
            <span className={styles.textoDestaque}>notas fiscais de serviço e produto</span>
            {` dos condomínios. Preencha abaixo os dados de acesso necessários.`}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ marginTop: "1rem" }}>
          <Typography variant="body2" className={styles.textoDestaque}>
            Condomínio: <span>{condominio?.nomeFantasia}</span>
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const visualizarErrors = () => {
    const mensagemErro: string[] = [];
    if (errorFederal) mensagemErro.push("Federal: " + errorFederal + ".");
    if (errorMunicipal) mensagemErro.push("Municipal: " + errorMunicipal + ".");

    if (mensagemErro.length > 0) {
      setShowModalErrors(true);
      setErrorContent({
        conteudoPrimario: mensagemErro[0] || "",
        conteudoSecundario: mensagemErro[1] || "",
        footerPrimaryLabel: "Fechar",
        onFooterPrimaryClick: () => setShowModalErrors(false),
      });
    }
  };

  const SessaoError = ({ error }: { error: string | null }) => {
    return error ? (
      <Grid item xs={12} className={styles.containerError}>
        <div>
          <RiErrorWarningFill className={styles.iconeError} color="#ED5565" />
        </div>
        <Typography variant="body2">
          {`Não foi possível acessar os sistemas para buscar as notas fiscais. `}
          <span className={styles.linkError} onClick={() => visualizarErrors()}>
            Verifique e corrija os dados informados
          </span>
          {` e tente novamente.`}
        </Typography>
      </Grid>
    ) : null;
  };

  const FooterModalConfiguracaoExterna = () => {
    return (
      <Row>
        <Col className="d-flex justify-content-end p-0">
          <CustomButton
            id="cancelarModal"
            label="Cancelar"
            onClick={() => handleClose()}
            variant="danger-alt"
            className="me-2"
          />
          <CustomButton
            id="testarConexao"
            label="Testar acesso e salvar"
            onClick={() => handleSubmit(onSubmit)()}
            variant="primary"
            className="ps-4 pe-4"
            disabled={!isBotaoHabilitado}
          />
        </Col>
      </Row>
    );
  };

  return (
    <>
      <CustomModal
        fecharModalAoClicarFora
        showModal={showModalConfiguracao}
        titulo="Configuração de busca externa de notas fiscais"
        size="lg"
        onCloseModal={handleClose}
        tipoModal="MODAL_LATERAL"
        scrollable
        hideCloseButton
        customFooter={FooterModalConfiguracaoExterna()}
      >
        <form
          autoComplete="off"
          onSubmit={(e) => e.preventDefault()}
          style={{ width: "100%" }}
        >
        <Grid container spacing={2} style={{ padding: "0.8rem" }}>
          <Grid item style={{ marginBottom: "1rem" }}>
            <Content />
          </Grid>
          <Grid item xs={12}>
            <ConfigurarCertificado control={control} register={register} setValue={setValue} />
          </Grid>
          <hr className={styles.linhaDivisoria} />
          <Grid item xs={12}>
            <ConfigurarPrefeitura control={control} register={register} setValue={setValue} />
          </Grid>

          {jaPossuiConfiguracaoPrefeitura && (
            <Grid item className={styles.containerButtonReplicar}>
              <IconButton size="small" className={styles.containerIconeReplicar} onClick={handleOpenModalReplicarAcesso}>
                <FaRepeat className={styles.iconeReplicar} />
                <Typography variant="body2" className={styles.textoDestaque}>
                  Replicar acesso para outros condomínios
                </Typography>
              </IconButton>
            </Grid>
          )}
          <Grid item xs={12} className={styles.containerSessaoDuvida}>
            <AiFillQuestionCircle className={styles.iconeDuvida} />
            <Typography className={styles.textoDuvida}>
              {`Dúvidas sobre como encontrar as informações acima? `}
              <a href="#" className={styles.linkDuvida} onClick={handleOpenModalAjuda}>
                Clique aqui e veja como descobrir.
              </a>
            </Typography>
          </Grid>
          <SessaoError error={errorFederal || errorMunicipal} />
        </Grid>
        </form>
      </CustomModal>

      {openModalReplicarAcesso && 
        <ModalReplicarAcesso
          openModal={openModalReplicarAcesso}
          onClose={handleCloseModalReplicarAcesso}
          condominioJaSelecionado={condominioId}
          getValues={getValues}
          setShowModalConfiguracaoBuscaExterna={setShowModalConfiguracaoBuscaExterna}
        />
      }

      <StandardModalBuscaExternaNf showModal={showModalAjuda} onCloseModal={handleCloseModalAjuda} />
      {(errorFederal || errorMunicipal) && (
        <StandardModal
          showModal={showModalErrors}
          onCloseModal={() => setShowModalErrors(false)}
          {...errorContent}
          footerPrimaryVariant="primary"
          footerSecondaryVariant="outline-primary"
          size="sm"
          fecharModalAoClicarFora={true}
        />
      )}
    </>
  );
};

export default ModalConfiguracaoBuscaExterna;